import { Component, inject } from '@angular/core';
import { FomentAreaStatusService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FomentAreaStatusCreateDto,
  FomentAreaStatusDto,
  FomentAreaStatusExcelDownloadDto,
  FomentAreaStatusUpdateDto,
} from '../proxy/controlling/dtos/foment-area-status';
import { FOMENTAREASTATUS_CONFIG, FOMENTAREASTATUS_FIELDS } from './foment-area-status.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-foment-area-status',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FomentAreaStatusService, ConfirmationService],
  templateUrl: './foment-area-status.html',
  styleUrl: './foment-area-status.scss',
})
export class FomentAreaStatus extends BaseCrudComponent<
  FomentAreaStatusDto,
  FomentAreaStatusCreateDto,
  FomentAreaStatusUpdateDto,
  FomentAreaStatusExcelDownloadDto
> {
  service = inject(FomentAreaStatusService);
  config = FOMENTAREASTATUS_CONFIG;
  fields = FOMENTAREASTATUS_FIELDS;

  protected prepareUpdateDto(data: any, selected: FomentAreaStatusDto): FomentAreaStatusUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FomentAreaStatus';
  }
}
